<template>
  <b-image
    :src="src"
    :ratio="ratio"
    :rounded="rounded"
    :custom-class="customClass"
    @load="onLoad"
    @error="onError"
  >
    <template #placeholder>
      <slot name="placeholder" />
    </template>
    <template #caption>
      <slot name="caption" />
    </template>
  </b-image>
</template>
<script>
export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'ImageView',
  emits: ['load', 'error'],
  slotsDefinition: {
    placeholder: {},
    caption: {}
  },
  props: {
    src: {
      type: String
    },
    ratio: {
      type: String
    },
    rounded: {
      type: Boolean
    },
    customClass: {
      type: String
    }
  },
  methods: {
    onLoad(...args) {
      this.$emit('load', ...args);
    },
    onError(...args) {
      this.$emit('error', ...args);
    }
  }
};
</script>
